// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, LoadProducts } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

export const XngLoadProducts: typeof LoadProducts = ({
    dispatch,
    parameter,
}) => {
    const { carouselId, relatedProductType, carouselType } = parameter;
    if(relatedProductType.toLowerCase() === "substitute" && carouselType === "relatedProducts") {
        dispatch({
            type: "xProductDetails/SetSubstituteProductsCarouselId",
            carouselId,
        } as any);
    }
};

addToEndOfChain(chain, XngLoadProducts);